// The live Supabase project coordinates — deliberately alone in their own
// module, and this file is the reason demo mode (R-034) is SAFE BY
// CONSTRUCTION rather than safe by promise.
//
// ── WHY THIS IS NOT IN client.js ANY MORE ──────────────────────────────────
// The demo build must be incapable of reaching the live database. A runtime
// flag cannot give that guarantee: `if (!DEMO) initClient(URL, KEY)` still
// SHIPS the URL and the key inside the bundle, one typo or one `?demo=0` away
// from a salesperson's laptop writing to production patient records.
//
// So the isolation is done by the BUILDER instead. build.mjs builds the demo
// bundle with an esbuild alias that points every `../db/creds.js` import at
// src/demo/creds.stub.js. The real values below are therefore not compiled
// into dist-demo/app.js at all — there is no code path, no flag, and no
// console incantation that can recover them, because the bytes are absent.
// build.mjs asserts exactly that after the build and FAILS the build if the
// project ref appears anywhere in the demo output.
//
// The anon/publishable key is the PUBLIC client key — meant to be embedded in
// client apps for anyone to view-source, so committing it here discloses
// nothing. All authorization comes from RLS + auth, never key secrecy. The
// demo isolation is not about protecting this key; it is about making it
// impossible for a synthetic-data build to point at real patients.
//
// ── TARGET: the PRODUCTION database (aswopexhihrigscbnzvj) ─────────────────
// Repointed BACK on 2026-07-23, reversing the 2026-07-20 move to 2.0's own
// project (pmlvsrgmewfiwgwaxpyo).
//
// WHY THE MOVE WAS WRONG: 2.0's own project holds sample data only, while the
// real patients — and, decisively, the LIVE PUBLIC CONSENT FORM — write to
// aswopexhihrigscbnzvj. So it was never a one-time data copy: every new consent
// keeps arriving in the old project. Cutting over on a separate database would
// have shown staff synthetic patients, hidden every real one, and written their
// work somewhere v_20 cannot read it. It also broke the pilot safety model in
// docs/PARITY_GATE.md §4, which is only safe BECAUSE both apps share one
// database ("mixed use is safe by construction").
//
// This also restores daily backups: the production project is on the Pro plan
// and backs up nightly, where 2.0's own project (Free) had none at all.
//
// NOTE: this project uses the LEGACY anon JWT, not the modern
// sb_publishable_… format. Both resolve to the anon role; supabase-js accepts
// either. The service_role key is NEVER committed and lives only in the
// dashboard. Key format is the one thing to re-check if auth ever 401s here.

export const SUPABASE_URL = 'https://aswopexhihrigscbnzvj.supabase.co';
export const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFzd29wZXhoaWhyaWdzY2JuenZqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjYzNDUyMTQsImV4cCI6MjA4MTkyMTIxNH0.ZpGhj77YJtI3lUm1EbZeqM_VzGi0eDgxJIC6jWLdZIA';

/** True for a build that carries real project coordinates. The stub sets false. */
export const IS_LIVE_CREDS = true;
